"use strict"

import React from "react"
import { Overlay } from "react-bootstrap"

import ObservationSelectorHolder from "./ObservationSelectorHolder"
import { CategorizedSelector } from "./CategorizedSelector"

export default class ObservationSelectorPopper extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}

    this.onClick = this.onClick.bind(this)
    this.hide = this.hide.bind(this)
  }

  render() {
    const button = React.Children.only(this.props.children)

    return (
      <React.Fragment>
        {React.cloneElement(button, {
          onClick: this.onClick,
          ref: (activator) => {
            this.activator = activator
          },
        })}
        <Overlay
          show={this.state.showing}
          onHide={this.hide}
          rootClose
          placement={this.props.placement ? this.props.placement : "bottom"}
          target={this.state.target}
        >
          <ObservationSelectorHolder>
            <CategorizedSelector {...this.props} onHide={this.hide} />
          </ObservationSelectorHolder>
        </Overlay>
      </React.Fragment>
    )
  }

  onClick(ev) {
    // Capture the target DOM element and store in in state, to avoid a
    // findDOMNode call later on (which is now recommended against).
    const target = ev.target

    this.setState((state) => ({
      showing: !state.showing,
      target: target,
    }))
  }

  hide() {
    this.setState({
      showing: false,
    })
  }
}
